import { useScrollReveal } from "@/hooks/useScrollReveal";
import { useLang, translations } from "../i18n";

export function WhatYouSkipSection() {
  const { lang } = useLang();
  const t = translations.whatYouSkip;
  const ref = useScrollReveal(60);

  return (
    <section className="bg-[var(--background-dark)] text-white py-20 md:py-28 lg:py-32 px-6 md:px-12 lg:px-20 relative overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none opacity-30"
        style={{
          backgroundImage: [
            "linear-gradient(rgba(255,255,255,0.02) 1px, transparent 1px)",
            "linear-gradient(90deg, rgba(255,255,255,0.02) 1px, transparent 1px)",
          ].join(", "),
          backgroundSize: "60px 60px",
        }}
      />
      <div ref={ref} className="max-w-6xl mx-auto relative z-10">
        <span className="reveal inline-flex items-center gap-2 text-xs font-semibold uppercase tracking-widest text-[var(--primary)] px-3 py-1.5 bg-[var(--primary)]/10 border border-[var(--primary)]/20 rounded-full mb-4">
          {t.badge[lang]}
        </span>
        <h2 className="reveal text-3xl md:text-[40px] font-extrabold tracking-tight leading-[1.15] mb-4">
          {t.heading[lang]}
        </h2>
        <p className="reveal text-[15px] text-[var(--text-muted-dark)] mb-12 max-w-lg leading-relaxed">
          {t.description[lang]}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {t.items[lang].map((item) => (
            <div
              key={item}
              className="reveal flex items-center gap-3 p-4 rounded-lg bg-white/[0.03] border border-white/[0.06]"
            >
              <span className="text-[var(--primary)] text-sm font-mono">×</span>
              <span className="text-sm text-white/60">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
